import React, { useContext } from 'react'
import CommonBox from './components/CommonBox'
import GifImagesSection from './components/GifImagesSection'
import RecommendTable from './components/RecommendTable'
import CommonButton from './components/CommonButton'
import LoginContext from './context'

const RecommendList = () => {
    const { isAuthenticated } = useContext(LoginContext)

    return (
        <>
            <section className='RecommendList-section'>
                <CommonBox heading=" 추천인 " englishHeading=" recommender" isEnglishHeadingOnMobile={true} isAuthenticated={isAuthenticated}>
                    <div className='grid grid-cols-3 lg:flex gap-1 mb-2 p-2.5 lg:p-0'>
                        <CommonButton label="추천인" link_src="#" type="link" />
                        <CommonButton label="마일리지" link_src="#" type="link" />
                        <div className='block lg:hidden'>
                            <CommonButton label="마일리지 내역" link_src="#" type="link" />
                        </div>
                        {/* <a href="#" className='bg-deep-blue font-Serif lg:font-sans-serif font-bold text-center w-auto h-10 lg:h-[35px] leading-10 lg:leading-[35px] block text-xs inline-block text-white box-border px-[15px] py-0 rounded-[5px] lg:rounded-[3px] border border-[#132d9a] hover:filter hover:brightness-[1.5] transition-all shadow-[inset_2px_2px_3px_rgb(255_255_255_/_30%),inset_-2px_-2px_3px_rgb(0_0_0_/_20%)] lg:shadow-none '>추천인</a>
                        <a href="#" className='bg-deep-blue font-Serif lg:font-sans-serif font-bold text-center w-auto h-10 lg:h-[35px] leading-10 lg:leading-[35px] block text-xs inline-block text-white box-border px-[15px] py-0 rounded-[5px] lg:rounded-[3px] border border-[#132d9a] hover:filter hover:brightness-[1.5] transition-all shadow-[inset_2px_2px_3px_rgb(255_255_255_/_30%),inset_-2px_-2px_3px_rgb(0_0_0_/_20%)] lg:shadow-none '>마일리지</a>
                        <a href="#" className='bg-deep-blue font-Serif lg:font-sans-serif font-bold text-center w-auto h-10 lg:h-[35px] leading-10 lg:leading-[35px] block lg:hidden text-xs inline-block text-white box-border px-[15px] py-0 rounded-[5px] lg:rounded-[3px] border border-[#132d9a] hover:filter hover:brightness-[1.5] transition-all shadow-[inset_2px_2px_3px_rgb(255_255_255_/_30%),inset_-2px_-2px_3px_rgb(0_0_0_/_20%)] lg:shadow-none '>마일리지 내역</a> */}
                    </div>
                    <RecommendTable />

                </CommonBox>
            </section>
            <section className='gif-section flex lg:hidden items-center justify-center'>
                <GifImagesSection />
            </section>

        </>
    )
}

export default RecommendList
